<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table v-if="load == true" :headers="headers" :items="delivery_status_list" id="my-table-id"
                sort-by="standard" class="elevation-1 mytable" dense :search="search" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Delivery Status</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn rounded color="success" outlined
                                @click="fnExcelReport('my-table-id', 'Delivery Status')"><v-icon
                                    color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mt-4 button" v-on="on" small>Add Delivery Status</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.name" persistent-hint outlined
                                                        dense :rules="[(v) => !!v || 'required']"
                                                        hint="For e.g. Pending, Dispatched, In-Transit, Out for delivery..."></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                    label="Active ?"></v-checkbox>
                                            </v-col>


                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>



                <template v-slot:[`item.isactive`]="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>




                <template v-slot:[`item.action`]="{ item }">
                    <v-avatar style size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit" style>edit</v-icon>
                    </v-avatar>

                </template>
                <template v-slot:[`item.delete`]="{ item }">
                    <v-avatar size="25" class="edit-avatar">
                        <v-icon class=" v-icon-size" color="red" @click="deleted(item)">mdi-trash-can</v-icon>
                    </v-avatar>

                </template>

            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    }, 
    data: () => ({
        valid: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        // extraBreadcrumbItems: [
        //     { text: "Delivery Status", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style2",
        color: "",
        snackbar: false,
        items: [],
        dialog: false,
        search: "",
        load: false,
        headers: [
            {
                text: "Name",
                value: "name",
            },
            {
                text: "Active",
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        delivery_status_list: [],

        editedIndex: -1,
        editedItem: {
            id: "",
            name: "",

            isactive: false,


        },
        defaultItem: {
            id: "",
            name: "",

            isactive: false,

        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Delivery Status" : "Edit Delivery Status";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() { },
    mounted() {
        this.onload();
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Status</th>
            </tr>`;

                this.delivery_status_list.forEach((s, index) => {
                    let isactive = s.isactive ? 'Yes' : 'No';
                    tab_text += `
            <tr>
                <td>${index + 1}</td>
                <td>${s.name}</td>
                <td>${isactive}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        onload() {
            axios
                .post("/EduStore/getDeliveryStatus")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.delivery_status_list = res.data.delivery_status_list;


                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        initializeErrorMsgFalse() {
            this.errorMsg.name = false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {

            this.editedIndex = this.delivery_status_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },



        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/EduStore/editDeliveryStatus", this.editedItem)
                        .then((res) => {
                            if (res.data.code == "SUCCESS") {
                                this.onload();

                                this.showSnackbar("#4caf50", "Delivery Status Updated Successfully..."); // show snackbar on success
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/EduStore/saveDeliveryStatus", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {

                                this.showSnackbar("#4caf50", "Delivery Status Added Successfully..."); // show snackbar on success
                                this.onload();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Delivery Status Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }
        }, // end of save()

        isValidated() {
            if (this.editedItem.name) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        }, // .....end of isValidated()
        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/EduStore/toggleDeliveryStatus", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Status of Delivery Status Changed Successfuly !"); 
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); 
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        deleted(item) {
            if (!confirm("Are You Sure You Want To Delete ...?")) return;
            const data = {
                id: item.id,

            };
            this.overlay = true;
            axios
                .post("/EduStore/deleteDeliveryStatus", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.onload();
                        this.showSnackbar("#4caf50", "Delivery Status Delete Successfully..."); // show snackbar
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
